import React from "react";
import { Input, Form, Checkbox, Radio, Space } from "antd";
import { getLangList } from '@/lib/i18n';
import Sale from "@/config/sale";
import { isPositiveCategory } from "@/lib/sale";
import { modalFromLayout } from "@/lib/antdElementFunction";

const { getBalanceInfo } = Sale;

interface props {
  form?: any;
  purchaseAmount: number;
  purchaseDiscountAmount: number;
  selectedGroupName: string;
}

interface state {
  isShowDiscount: boolean,
}

class ModalCheckout extends React.Component<props, state> {
  state = {
    isShowDiscount: false,
  };

  saleT: any = getLangList("sale");
  errorT: any = getLangList("error");
  inputRef: any = React.createRef();

  componentDidMount() {
    const { form, purchaseAmount, purchaseDiscountAmount } = this.props;

    setTimeout(() => { this.inputRef.current.focus(); }, 100);
    form.setFieldsValue({
      purchaseAmount: `$${purchaseAmount}`,
      purchaseDiscountAmount: `$${purchaseDiscountAmount}`
    });
  }

  getBalanceInfo = () => {
    const { form, purchaseAmount, purchaseDiscountAmount } = this.props;
    const { checkoutBy, checkoutValue } = form.getFieldsValue();
    const params = { [checkoutBy]: checkoutValue };

    getBalanceInfo(params).then((res: any) => {
      const { balance = 0, userAccountId, nameCn, nameEn, roleId } = res?.value ?? {};
      const isShowDiscount = roleId !== 2;

      form.setFieldsValue({
        balance: `$${balance}`,
        userAccountId,
        name: `${nameEn} - ${nameCn}`,
        isDiscount: isShowDiscount,
        purchaseAmount: isShowDiscount ? `$${purchaseAmount - purchaseDiscountAmount}` : `$${purchaseAmount}`,
      });

      this.setState({ isShowDiscount })
    });
  }

  render() {
    const { form, selectedGroupName } = this.props;
    const { isShowDiscount } = this.state;
    const saleT = this.saleT;
    const errorT = this.errorT;

    return (
      <Form
        className="admin-form"
        style={{ marginTop: 20 }}
        {...modalFromLayout}
        form={form}
        initialValues={{
          checkoutBy: 'accessCardNumber',
          itemPrice: 0,
          itemQuantity: 0,
        }}
      >
        <Form.Item name="checkoutBy" label={saleT.CHECKOUT_BY} rules={[{ required: true }]}>
          <Radio.Group onChange={() => this.inputRef.current.focus()}>
            <Space>
              <Radio value='accessCardNumber'>{saleT.ACCESS_CARD_NUMBER}</Radio>
              <Radio value='username'>{saleT.ACCOUNT}</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={errorT.PLEASE_ENTER('')}
          name="checkoutValue"
          rules={[{ required: true }]}
        >
          <Input onPressEnter={this.getBalanceInfo} ref={this.inputRef} placeholder={`${saleT.ACCESS_CARD_NUMBER}、${saleT.STUDENT_ID_PLACEHOLDER}`} />
        </Form.Item>

        <Form.Item label={saleT.PURCHASER} name="name">
          <Input bordered={false} disabled className="sale-disabled-input" />
        </Form.Item>

        <Form.Item
          label={saleT.BALANCE}
          name="balance"
          rules={[
            () => ({
              validator(rule, value) {
                const purchaseAmountString = form.getFieldValue('purchaseAmount');
                const purchaseAmount = purchaseAmountString.substring(1, purchaseAmountString.length) * 1;
                const balance = value.substring(1, value.length) * 1;

                if (isPositiveCategory(selectedGroupName)) {
                  return Promise.resolve();
                } else if (balance >= purchaseAmount) {
                  return Promise.resolve();
                }
                return Promise.reject(saleT.BALANCE_NOT_ENOUGH);
              },
            }),
          ]}
        >
          <Input bordered={false} disabled className="sale-disabled-input" />
        </Form.Item>

        <Form.Item
          style={{ display: isShowDiscount ? 'block' : 'none' }}
          label={saleT.DISCOUNT}
          name="purchaseDiscountAmount"
        >
          <Input bordered={false} disabled className="sale-disabled-input" />
        </Form.Item>

        <Form.Item label={saleT.TOTAL} name="purchaseAmount">
          <Input bordered={false} disabled className="sale-disabled-input" />
        </Form.Item>

        <Form.Item style={{ display: 'none' }} name="userAccountId">
          <Input />
        </Form.Item>

        <Form.Item style={{ display: 'none' }} name="isDiscount" valuePropName='checked'>
          <Checkbox />
        </Form.Item>
      </Form >
    );
  }
}

export default ModalCheckout;